export const copyToClipboard = () => {
  const button = document.querySelector("[data-wm-copy-to-clipboard]");

  if (!button) {
    return;
  }

  let wasAlreadySent = false;
  let shareUrl = null;

  const fetchAndCopyToClipboard = async () => {
    if (!wasAlreadySent) {
      shareUrl = await fetch(button.dataset.wmCopyToClipboard)
        .then((res) => res.text())
        .then((data) => data);

      wasAlreadySent = true;
    }

    navigator.clipboard.writeText(shareUrl);
    button.classList.add("link-copied");

    setTimeout(() => {
      button.classList.remove("link-copied");
    }, 1200);
  };

  button.addEventListener("click", fetchAndCopyToClipboard);
};
